import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Dialog,
  TextField,
  Typography,
  Alert,
} from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useWSContext } from '../../../contexts/WebSocketContext';
import AssuntoAtendimentoEnum from '../../../Enum/AssuntosAtendimentoEnum';

// Remove tudo que não é número
const limparTelefone = (telefone) => telefone.replace(/\D/g, '');

const formatarTelefone = (telefone) => {
  const cleanValue = limparTelefone(telefone);

  if (cleanValue.length === 11) {
    return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2, 7)}-${cleanValue.slice(7)}`;
  }

  if (cleanValue.length === 10) {
    return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2, 6)}-${cleanValue.slice(6)}`;
  }

  if (cleanValue.length >= 12 && cleanValue.length <= 14) {
    return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2, 8)}-${cleanValue.slice(8)}`;
  }

  if (cleanValue.length === 15) {
    return `(${cleanValue.slice(0, 3)}) ${cleanValue.slice(3, 8)}-${cleanValue.slice(8)}`;
  }

  return telefone;
};

const validarNumerosIguais = (value) => {
  const cleanValue = limparTelefone(value);
  return !/^([0-9])\1*$/.test(cleanValue);
};

export default function ConfirmarCampos({
  navigate,
  userData,
  setUserData,
  assunto,
}) {
  const { loadingAtendimento, successStartService, handleStartAtendimento } =
    useWSContext();

  const [showSerieDialog, setShowSerieDialog] = useState(false);

  const validationSchema = Yup.object({
    name_user: Yup.string()
      .min(3, 'O nome deve ter pelo menos 3 caracteres.')
      .required('Por favor, informe seu nome.'),
    email_user: Yup.string()
      .email('Digite um e-mail válido.')
      .required('Por favor, informe seu e-mail.'),
    tel_user: Yup.string()
      .required('O número de telefone é obrigatório.')
      .test('validLength', 'O telefone deve ter entre 10 e 15 dígitos.', (value) => {
        if (!value) return false;
        const clean = limparTelefone(value);
        return clean.length >= 10 && clean.length <= 15;
      })
      .test(
        'notEqualNumbers',
        'O número não pode ser uma sequência de números iguais.',
        validarNumerosIguais
      ),
  });

  function setFieldDatas(formik) {
    const newUserData = {
      assunto,
      name_user: formik.values.name_user,
      email_user: formik.values.email_user,
      tel_user: limparTelefone(formik.values.tel_user),
    };
    setUserData(newUserData);
  }

  function startAtendimento(formik) {
    const userSession = JSON.parse(localStorage.getItem('tecnozap_user_session')) || {
      numSerie: '',
    };

    if (!userSession.numSerie || userSession.numSerie.trim() === '') {
      setShowSerieDialog(true);
      return;
    }

    setFieldDatas(formik);
    handleStartAtendimento();
  }

  const handleVoltarAoInicio = () => {
    localStorage.removeItem('tecnozap_user_session');
    setShowSerieDialog(false);
    navigate(0); // ou a tela inicial do seu app
  };

  useEffect(() => {
    if (successStartService) {
      navigate(5);
    } else {
      navigate(4);
    }
  }, [successStartService]);

  const formik = useFormik({
    initialValues: {
      name_user: userData?.name_user || '',
      email_user: userData?.email_user || '',
      tel_user: userData?.tel_user || '',
    },
    validationSchema,
    onSubmit: () => {
      const newUserData = {
        assunto,
        name_user: formik.values.name_user,
        email_user: formik.values.email_user,
        tel_user: limparTelefone(formik.values.tel_user),
      };
      setUserData(newUserData);
      handleStartAtendimento();
    },
  });

  useEffect(() => {
    if (successStartService) {
      navigate(5);
    } else {
      navigate(4);
    }
  }, [successStartService]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" component="h3" color="success.main" sx={{ mb: 3 }}>
        Suporte online
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Por favor, confirme os campos a seguir e em breve iniciaremos seu atendimento!
      </Typography>

      <form
        onSubmit={formik.handleSubmit}
        style={{ display: 'flex', height: '100%', flexDirection: 'column' }}
      >
        <TextField
          value={AssuntoAtendimentoEnum[assunto]}
          variant="outlined"
          fullWidth
          sx={{ mb: 3, backgroundColor: '#eee', borderRadius: 1 }}
          disabled
        />

        <TextField
          label="Nome"
          name="name_user"
          value={formik.values.name_user}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.name_user && Boolean(formik.errors.name_user)}
          helperText={formik.touched.name_user && formik.errors.name_user}
          variant="outlined"
          fullWidth
          sx={{ mb: 3 }}
        />

        <TextField
          label="E-mail"
          name="email_user"
          value={formik.values.email_user}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email_user && Boolean(formik.errors.email_user)}
          helperText={formik.touched.email_user && formik.errors.email_user}
          variant="outlined"
          fullWidth
          sx={{ mb: 3 }}
        />

<TextField
  label="Telefone"
  name="tel_user"
  inputProps={{ inputMode: 'numeric' }}
  value={formik.values.tel_user}
  onChange={(e) => {
    const val = e.target.value;
    // Apenas números
    const onlyNumbers = val.replace(/\D/g, '');
    formik.setFieldValue('tel_user', onlyNumbers);
  }}
  onBlur={formik.handleBlur}
  error={formik.touched.tel_user && Boolean(formik.errors.tel_user)}
  helperText={formik.touched.tel_user && formik.errors.tel_user}
  variant="outlined"
  fullWidth
  sx={{ mb: 3 }}
/>


        <Box sx={{ display: 'flex', flex: 1, mt: -1 }}>
          <Button
            variant="outlined"
            size="large"
            sx={{ width: '100%', mr: 1, height: 48 }}
            onClick={() => navigate(3)}
          >
            Voltar
          </Button>
          <LoadingButton
            loading={loadingAtendimento}
            type="submit"
            variant="contained"
            sx={{ width: '100%', height: 48 }}
            disabled={!formik.isValid}
          >
            Iniciar atendimento
          </LoadingButton>
        </Box>
      </form>

      {/* Diálogo de erro de número de série */}
      <Dialog
        open={showSerieDialog}
        onClose={() => setShowSerieDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <Box p={3} textAlign="center">
          <Typography variant="h6" color="error" sx={{ mb: 2 }}>
            Ops! Número de série não encontrado
          </Typography>
          <Typography variant="body2" sx={{ mb: 3 }}>
            Parece que seu número de série não foi encontrado no sistema. Isso pode ter ocorrido por um problema no login. Que tal voltar ao início e tentar novamente?
          </Typography>
          <Button variant="contained" color="primary" onClick={handleVoltarAoInicio}>
            Voltar ao início
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
}
